<template>
  <div class="overlay-frame">
    <img class="leaves leaves--l leaves--m leaves--m-bl" data-src="/img/overlay/leaves--bottom-left.png" alt="">
    <img class="leaves leaves--r leaves--m leaves--m-br" data-src="/img/overlay/leaves--bottom-right.png" alt="">
    <img class="leaves leaves--l leaves--m leaves--m-tl" data-src="/img/overlay/leaves--top-left.png" alt="">
    <img class="leaves leaves--r leaves--m leaves--m-tr" data-src="/img/overlay/leaves--top-right.png" alt="">
    <div class="overlay-fram-mobile">
      <div class="overlay-fram-mobile__cont" v-if="!$inApp" :style="{ transform: `translateX(${translate.left}px)` }">
        <img
          class="leaves leaves--m leaves--frame--left"
          data-src="/img/overlay/mobile-frame--left.png"
          alt=""
        >
      </div>
      <div class="overlay-fram-mobile__cont" v-if="!$inApp" :style="{ transform: `translateX(${translate.right}px)` }">
        <img
          class="leaves leaves--m leaves--frame--right"
          data-src="/img/overlay/mobile-frame--right.png"
          alt=""
        >
      </div>

      <img v-if="$inApp" class="leaves leaves--m leaves--frame" data-src="/img/overlay/mobile-frame--app.png" alt="">
      <img v-else class="leaves leaves--m leaves--frame" data-src="/img/overlay/mobile-frame.png" alt="">
    </div>

    <img class="leaves leaves--l leaves--tl" data-src="/img/overlay/leaves--top-01.png" alt="">
    <img class="leaves leaves--l leaves--lb" data-src="/img/overlay/leaves--left-01.png" alt="">
    <img class="leaves leaves--l leaves--lt" data-src="/img/overlay/leaves--left-00.png" alt="">
    <img class="leaves leaves--r leaves--rb" data-src="/img/overlay/leaves--right-01.png" alt="">
    <img class="leaves leaves--r leaves--rt" data-src="/img/overlay/leaves--right-00.png" alt="">
    <img class="leaves leaves--r leaves--tr" data-src="/img/overlay/leaves--top-00.png" alt="">
  </div>
</template>

<script>
import gsap from 'gsap';
import { isTouchDevice } from '@/scripts/utils';

export default {
  name: 'OverlayFrame',

  computed: {
    translate() {
      const t = { left: 0, right: 0 };
      const halfwidth = window.innerWidth / 2;

      t.left = Math.max((this.$store.state.playerDistance / halfwidth) * 10, -5);
      t.right = Math.min((this.$store.state.playerDistance / halfwidth) * 10, 5);

      return t;
    },
  },

  data() {
    return {
      isTouchDevice: isTouchDevice(),
      assets: {
        dsk: [
          '/img/overlay/leaves--top-01.png',
          '/img/overlay/leaves--left-01.png',
          '/img/overlay/leaves--left-00.png',
          '/img/overlay/leaves--right-01.png',
          '/img/overlay/leaves--right-00.png',
          '/img/overlay/leaves--top-00.png',
          '/img/overlay/leaves--m-bl.png',
          '/img/overlay/leaves--m-br.png',
          '/img/overlay/leaves--m-tl.png',
          '/img/overlay/leaves--m-tr.png',
        ],
        mobile: [
          '/img/overlay/leaves--m-bl.png',
          '/img/overlay/leaves--m-br.png',
          '/img/overlay/leaves--m-tl.png',
          '/img/overlay/leaves--m-tr.png',
          this.$inApp ? '/img/overlay/mobile-frame.png' : '/img/overlay/mobile-frame--app.png',
          '/img/overlay/mobile-frame--left.png',
          '/img/overlay/mobile-frame--right.png',
        ],
        app: [],
      },
    };
  },

  methods: {
    async load() {
      const promises = [];
      const type = (this.isTouchDevice && window.innerWidth >= 568) || !this.isTouchDevice ? 'dsk' : 'mobile'; // eslint-disable-line

      this.assets[type].forEach((asset) => {
        promises.push(() => {
          const img = new Image();
          img.src = asset;
          return img.decode();
        });
      });

      await Promise.all(promises).then(() => this.enter());
    },
    replaceImgs() {
      const selector = (this.isTouchDevice && window.innerWidth >= 568) || !this.isTouchDevice ? '.leaves' : '.leaves.leaves--m';

      [...this.$el.querySelectorAll(selector)].forEach((img) => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
    },
    enter() {
      const tl = gsap.timeline({ delay: 0.5 });

      this.replaceImgs();

      if (this.$el.querySelector('.overlay-frame .leaves--frame')) {
        gsap.from('.overlay-frame .leaves--frame', {
          scale: 1.5,
          autoAlpha: 1,
          duration: 1.2,
          ease: 'power3.out',
        }, 'start');

        if (!this.$inApp) {
          gsap.from('.overlay-frame .leaves--frame--left', {
            xPercent: -50,
            autoAlpha: 0,
            duration: 1.2,
            ease: 'power3.out',
            clearProps: 'all',
          }, 'start');
          gsap.from('.overlay-frame .leaves--frame--right', {
            xPercent: 50,
            autoAlpha: 0,
            duration: 1.2,
            ease: 'power3.out',
            clearProps: 'all',
          }, 'start');
        }
      }

      tl.addLabel('start')
        .from('.overlay-frame .leaves--l', {
          x: -150,
          yPercent: -50,
          autoAlpha: 0,
          duration: 1.2,
          stagger: 0.1,
          ease: 'flap',
        }, 'start')
        .from('.overlay-frame .leaves--r', {
          x: 150,
          yPercent: -50,
          autoAlpha: 0,
          duration: 1.2,
          stagger: 0.1,
          ease: 'flap',
        }, 'start');

      return tl;
    },
    leave() {
      const tl = gsap.timeline();
      const autoAlpha = this.isTouchDevice && window.innerWidth >= 568 ? 1 : 0;

      tl.addLabel('start')
        .to('.overlay-frame .leaves--m-bl', {
          yPercent: 0,
          autoAlpha,
          x: '-5vh',
          ease: 'power3.in',
          duration: 1.1,
        }, 'start')
        .to('.overlay-frame .leaves--m-br', {
          yPercent: 0,
          autoAlpha,
          x: '5vh',
          ease: 'power3.in',
          duration: 1.2,
        }, 'start')
        .to('.overlay-frame .leaves--m-tl', {
          yPercent: -100,
          autoAlpha,
          x: '-7vh',
          ease: 'power3.in',
          duration: 1.2,
        }, 'start')
        .to('.overlay-frame .leaves--m-tr', {
          yPercent: -100,
          autoAlpha,
          x: '7vh',
          ease: 'power3.in',
          duration: 1.1,
        }, 'start');
    },
  },
};
</script>

<style lang="scss" scoped>
.overlay-frame {
  @include full(true);

  overflow: hidden;
  pointer-events: none;

  .overlay-fram-mobile {
    @include full();

    @include mq(ipadP) {
      opacity: 0;
    }
  }

  .overlay-fram-mobile__cont {
    @include full();
  }

  .leaves {
    position: absolute;
    top: 50%;
    height: 120%;
    width: auto;

    transform: translateY(-50%);

    &--frame {
      @include full();
      top: 50%;

      @include mq(ipadP) {
        display: none;
      }

      &--left {
        left: unset;
        right: calc(50% + 16vh);
      }
      &--right {
        left: calc(50% + 15vh);
      }
    }

    &--m-tl {
      top: 10%;
      height: 60%;
      right: calc(50% - 8vh);
    }
    &--m-tr {
      top: 10%;
      height: 75%;
      left: calc(50% - 12vh);
    }
    &--m-bl {
      top: unset;
      bottom: -75%;
      height: 100%;
      right: calc(50% - 10vh);
    }
    &--m-br {
      top: unset;
      bottom: -50%;
      height: 75%;
      left: calc(50% - 16vh);
    }

    &--lt {
      top: 50%;
      height: 140%;
      right: calc(50% + 30vh);
    }
    &--lb {
      top: 48%;
      height: 140%;
      right: calc(50% + 10vh);
    }
    &--rt {
      top: 44%;
      left: calc(50% + 28vh);
      height: 148%;
    }
    &--rb {
      top: 54%;
      left: calc(50% + 6.8vh);
    }
    &--tl {
      top: 8%;
      left: calc(50% - 30vh);
      height: 38%;
    }
    &--tr {
      top: -18%;
      left: calc(50% - 23vh);
      height: 60%;
    }
  }
}
</style>
